// eslint-disable-next-line no-restricted-imports -- the one module that may import zod directly
import { z } from "zod";

// Zod compiles object parsers with `new Function`, which the CSP forbids; the interpreted parser is plenty here.
z.config({ jitless: true });

export { z };
